/*
  Dekogreen · menú nuevo (plan 2, 29-09-2026): megamenú del ordenador (<dk-megamenu>) y cajón del móvil (<dk-cajon>).
  Sustituye al desplegable del tema (assets/menu-dropdown.js), que se abría con el foco, pedía doble clic y no
  siempre cerraba con Esc.
*/
(function () {
  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)');
  // La medición la carga dk-medicion.js en window.dkMedir
  function medir(nombre, datos) { if (typeof window.dkMedir === 'function') window.dkMedir(nombre, datos); }

  // ─── Megamenú del ordenador ──────────────────────────────────────────────────
  // Cada apartado es un botón: se abre con clic, Intro o Espacio, nunca al recibir el foco. Con el ratón, 150 ms
  // de espera antes de abrir y un margen al salir. Esc cierra y devuelve el foco. Un solo panel abierto a la vez.
  class DkMegamenu extends HTMLElement {
    connectedCallback() {
      if (this.dkListo) return;
      this.dkListo = true;
      this.abierto = null;
      this.contados = {};
      var menu = this;
      [].forEach.call(this.querySelectorAll('.dk-nav__boton[aria-controls]'), function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          clearTimeout(menu.tAbrir);
          // Si lo abrió el ratón, el clic que suele venir detrás lo confirma: cerrarlo obligaría a un segundo clic
          if (menu.abierto === b && !menu.porRaton) menu.cerrar(false);
          else menu.abrir(b, e.detail === 0 ? 'teclado' : 'clic');
          menu.porRaton = false;
        });
        b.addEventListener('mouseenter', function () {
          clearTimeout(menu.tCerrar);
          clearTimeout(menu.tAbrir);
          menu.tAbrir = setTimeout(function () {
            if (menu.abierto === b) return;
            menu.abrir(b, 'raton');
            menu.porRaton = true;
          }, menu.abierto ? 60 : 150);
        });
        b.addEventListener('mouseleave', function () { clearTimeout(menu.tAbrir); });
      });
      // Los apartados que son enlace directo cierran el panel abierto al pasar por encima
      [].forEach.call(this.querySelectorAll('a.dk-nav__boton'), function (a) {
        a.addEventListener('mouseenter', function () {
          clearTimeout(menu.tAbrir);
          if (menu.abierto) menu.tAbrir = setTimeout(function () { menu.cerrar(false); }, 150);
        });
      });
      this.addEventListener('mouseenter', function () { clearTimeout(menu.tCerrar); });
      this.addEventListener('mouseleave', function () {
        clearTimeout(menu.tAbrir);
        menu.tCerrar = setTimeout(function () { menu.cerrar(false); }, 350);
      });
      // Al salir con el tabulador del menú, el panel se cierra
      this.addEventListener('focusout', function (e) {
        if (menu.abierto && e.relatedTarget && !menu.contains(e.relatedTarget)) menu.cerrar(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.abierto) {
          var dentro = menu.contains(document.activeElement);
          menu.cerrar(dentro);
        }
      });
      document.addEventListener('click', function (e) {
        if (menu.abierto && !menu.contains(e.target)) menu.cerrar(false);
      });
      // Si la página se desplaza con un panel abierto, el panel se cierra (la cabecera fija esconde la fila del menú)
      window.addEventListener('scroll', function () {
        if (menu.abierto && Math.abs(window.pageYOffset - menu.desplazamiento) > 60) menu.cerrar(false);
      }, { passive: true });
      window.addEventListener('resize', function () { if (menu.abierto) menu.ajustarAlto(menu.panel(menu.abierto)); });
    }

    // El panel no pasa del alto de la ventana: lo que no quepa se desplaza dentro del panel, con el pie a la vista
    ajustarAlto(p) {
      var base = p.offsetParent ? p.offsetParent.getBoundingClientRect().bottom : p.getBoundingClientRect().top;
      p.style.setProperty('--dk-panel-alto', Math.max(240, Math.floor(window.innerHeight - base)) + 'px');
    }

    panel(b) { return document.getElementById(b.getAttribute('aria-controls')); }

    abrir(b, modo) {
      if (this.abierto === b) return;
      this.contar(b, modo);
      var antes = this.abierto;
      if (antes) {
        antes.setAttribute('aria-expanded', 'false');
        this.panel(antes).hidden = true;
      }
      var p = this.panel(b);
      if (!p) return;
      // Las fotos se piden al abrir, al tamaño de la pantalla, y aparecen fundiéndose cuando llegan
      [].forEach.call(p.querySelectorAll('img[data-src]'), function (img) {
        img.setAttribute('data-dk-carga', '');
        var lista = function () { img.removeAttribute('data-dk-carga'); };
        img.addEventListener('load', lista, { once: true });
        img.addEventListener('error', lista, { once: true });
        if (img.hasAttribute('data-srcset')) {
          img.srcset = img.getAttribute('data-srcset');
          img.removeAttribute('data-srcset');
        }
        img.src = img.getAttribute('data-src');
        img.removeAttribute('data-src');
      });
      this.desplazamiento = window.pageYOffset;
      // Primera vez: entra en 500 ms fundiéndose y bajando 1 rem; al pasar de un apartado a otro, solo cambia en 250 ms
      var clase = antes ? 'dk-panel--cambia' : 'dk-panel--entra';
      if (!quieto.matches) {
        p.classList.add(clase);
        if (antes) p.classList.add('dk-panel--rapido');
      }
      p.hidden = false;
      this.ajustarAlto(p);
      b.setAttribute('aria-expanded', 'true');
      this.abierto = b;
      document.body.classList.add('dk-megamenu-abierto');
      if (!quieto.matches) {
        p.getBoundingClientRect(); // fija el estado inicial antes de animar
        requestAnimationFrame(function () {
          p.classList.remove(clase);
          if (antes) setTimeout(function () { p.classList.remove('dk-panel--rapido'); }, 300);
        });
      }
    }

    // Medición: un apartado cuenta como abierto si sigue abierto 0,7 s (cruzar la barra con el ratón no cuenta), y una
    // sola vez por página
    contar(b, modo) {
      clearTimeout(this.tContar);
      var menu = this;
      var apartado = b.getAttribute('data-dk-apartado');
      if (this.contados[apartado]) return;
      this.tContar = setTimeout(function () {
        if (menu.abierto !== b || menu.contados[apartado]) return;
        menu.contados[apartado] = true;
        medir('dk_menu_abierto', { menu: 'escritorio', apartado: apartado, modo: modo || 'clic' });
      }, 700);
    }

    cerrar(devolverFoco) {
      var b = this.abierto;
      if (!b) return;
      clearTimeout(this.tAbrir);
      clearTimeout(this.tContar);
      b.setAttribute('aria-expanded', 'false');
      this.panel(b).hidden = true;
      this.abierto = null;
      this.porRaton = false;
      document.body.classList.remove('dk-megamenu-abierto');
      if (devolverFoco) b.focus();
    }
  }
  if (!customElements.get('dk-megamenu')) customElements.define('dk-megamenu', DkMegamenu);

  // ─── Cajón del móvil ─────────────────────────────────────────────────────────
  // Va dentro del <header-drawer> del tema, que lo abre y lo cierra. Aquí: una pantalla por apartado (botón con
  // aria-expanded), atrás, Esc (vuelve a la primera pantalla sin cerrar el cajón), 250 ms de paso y ninguno si se pide.
  class DkCajon extends HTMLElement {
    connectedCallback() {
      if (this.dkListo) return;
      this.dkListo = true;
      this.contados = {};
      var cajon = this;
      this.inicio = this.querySelector('[data-dk-inicio]');
      this.addEventListener('click', function (e) {
        var t = e.target;
        var abrir = t.closest('.dk-mfila[aria-controls]');
        if (abrir) { e.preventDefault(); cajon.mostrar(abrir); return; }
        if (t.closest('[data-dk-atras]')) { e.preventDefault(); cajon.volver(true); return; }
        // El buscador se abre en este mismo toque (el iPhone solo saca el teclado así); el clic no sigue hasta la página,
        // donde el buscador lo tomaría por un clic fuera y se cerraría
        if (t.closest('[data-dk-abrir-buscador]')) { e.preventDefault(); e.stopPropagation(); cajon.buscar(); return; }
        // El −10 %: popup.js abre el boletín con el mismo clic; aquí solo se cierra el cajón
        if (t.closest('a[href="#dk-popup"]')) cajon.cerrarCajon();
      });
      this.addEventListener('keyup', function (e) {
        if ((e.code === 'Escape' || e.key === 'Escape') && cajon.abierta) {
          e.stopPropagation(); // el tema cerraría el cajón entero
          cajon.volver(true);
        }
      });
      document.addEventListener('menudrawer:close', function () { cajon.volver(false); });
    }

    mostrar(boton) {
      var p = document.getElementById(boton.getAttribute('aria-controls'));
      if (!p) return;
      this.origen = boton;
      boton.setAttribute('aria-expanded', 'true');
      p.hidden = false;
      var apartado = boton.getAttribute('data-dk-apartado');
      if (!this.contados[apartado]) {
        this.contados[apartado] = true;
        medir('dk_menu_abierto', { menu: 'movil', apartado: apartado, modo: 'toque' });
      }
      if (!quieto.matches) {
        p.classList.add('dk-pantalla--fuera');
        p.getBoundingClientRect();
        requestAnimationFrame(function () { p.classList.remove('dk-pantalla--fuera'); });
      }
      this.abierta = p;
      this.classList.add('dk-cajon--dentro');
      var atras = p.querySelector('[data-dk-atras]');
      if (typeof window.trapFocus === 'function') window.trapFocus(p, atras);
      else if (atras) atras.focus();
    }

    volver(conFoco) {
      var p = this.abierta;
      if (!p) return;
      this.abierta = null;
      this.classList.remove('dk-cajon--dentro');
      var fin = function () { p.hidden = true; p.classList.remove('dk-pantalla--fuera'); };
      if (quieto.matches || !conFoco) fin();
      else { p.classList.add('dk-pantalla--fuera'); setTimeout(fin, 250); }
      if (this.origen) {
        this.origen.setAttribute('aria-expanded', 'false');
        if (conFoco) {
          if (typeof window.trapFocus === 'function') window.trapFocus(this.closest('details') || this, this.origen);
          else this.origen.focus();
        }
      }
    }

    cerrarCajon() {
      this.dispatchEvent(new CustomEvent('drawer:force-close', { bubbles: true, cancelable: true, composed: true }));
    }

    buscar() {
      this.cerrarCajon();
      // El buscador de la cabecera que se ve (el tema pinta dos: ordenador y móvil)
      var modales = [].slice.call(document.querySelectorAll('search-modal'));
      var visible = modales.filter(function (m) {
        var s = m.querySelector('summary');
        return s && s.getBoundingClientRect().width > 0;
      })[0] || modales[0];
      if (visible && typeof visible.open === 'function') visible.open();
    }
  }
  if (!customElements.get('dk-cajon')) customElements.define('dk-cajon', DkCajon);
})();
